import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/Loaders";

export const ProtectedRoute = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading || user === undefined)
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "owner" ? "/owner" : "/";
    return <Navigate to={home} replace />;
  }
  return children;
};
